import React from "react";
import LogoMark from "./LogoMark";

function splitRoles(role) {
  if (!role) return [];
  return role
    .split(/\s*&\s*|\s*,\s*|\s+and\s+/i)
    .map((r) => r.trim())
    .filter(Boolean);
}

// The first project always renders as a full-width row with an image
// placeholder; any additional projects are collapsed behind a
// "N more projects" toggle and shown as a two-column mini grid.
function CompanyBlock({
  company,
  companyIndex,
  isOpen,
  onToggleExpand,
  onOpenCaseStudy,
}) {
  const [first, ...rest] = company.projects;
  const hidden = rest.length;
  const chips = splitRoles(first.role);

  return (
    <>
      <div
        className="proj-row"
        onClick={() => onOpenCaseStudy(companyIndex, 0)}
      >
        <div className="proj-row-left">
          <div className="pr-logo">
            <LogoMark companyId={company.id} fallback={company.short} />
          </div>
          <div className="pr-tag">{first.tag}</div>
          <div>
            <h2 className="pr-title">{first.title}</h2>
          </div>
          <div className="pr-desc">{first.desc}</div>
          {chips.length > 0 && (
            <div className="pr-chips">
              {chips.map((r) => (
                <span className="pr-chip" key={r}>
                  {r}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="proj-row-right">
          <div
            className="bg-canvas"
            style={{ "--proj-color": company.color || "#274dea" }}
          >
            <div className="proj-media">
              <div className="proj-img">
                {first.img ? (
                  <>
                    <img src={first.img} alt={first.title} />
                    <div className="proj-img-caption">{first.title}</div>
                  </>
                ) : (
                  <span className="proj-img-lbl">Project image</span>
                )}
              </div>
              {first.metrics && first.metrics.length > 0 && (
                <div className="proj-media-metrics">
                  {first.metrics.map((m, i) => (
                    <div className="proj-media-metric" key={i}>
                      <div className="proj-media-metric-n">{m.n}</div>
                      <div className="proj-media-metric-l">{m.l}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {isOpen && hidden > 0 && (
        <div className="proj-mini-grid">
          {rest.map((p, idx) => (
            <div
              className="proj-mini"
              key={p.title}
              onClick={() => onOpenCaseStudy(companyIndex, idx + 1)}
            >
              <div className="proj-mini-img" style={{ "--proj-color": "grey" }}>
                {p.img ? (
                  <img style={{ width: "80%" }} src={p.img} alt={p.title} />
                ) : (
                  <span>Project image</span>
                )}
              </div>
              <div className="proj-mini-tag">{p.tag}</div>
              <div className="proj-mini-title">{p.title}</div>
              <div className="proj-mini-desc">{p.desc}</div>
            </div>
          ))}
        </div>
      )}

      {hidden > 0 && (
        <div
          className={"read-more-btn" + (isOpen ? " is-collapse" : "")}
          onClick={(e) => {
            e.stopPropagation();
            onToggleExpand();
          }}
        >
          <span className="rm-arrow">↓</span>
          <span>
            {isOpen
              ? "Show less"
              : `${hidden} more ${company.name} ${
                  hidden === 1 ? "project" : "projects"
                }`}
          </span>
        </div>
      )}
    </>
  );
}

export default CompanyBlock;
